import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { secondaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface HomepageBlock10Props extends ComponentPropsWithRef<"div"> {
  buttons: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock10 = forwardRef<HTMLDivElement, HomepageBlock10Props>(
  ({ header, buttons, footer, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: secondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          style={{
            ...backgroundStyles,
          }}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-gap-6 md:wb-gap-10 wb-flex wb-flex-col">
                <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-gap-2 md:wb-gap-6 wb-text-center">
                  {header}
                </BlockSection.NestedBlock>
                <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-9">
                  <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-flex-row [&_*]:wb-w-[unset] wb-items-center">
                    {buttons}
                  </BlockSection.NestedBlock>
                  <BlockSection.NestedBlock className="wb-text-center">
                    {footer}
                  </BlockSection.NestedBlock>
                </div>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock10.displayName = "HomepageBlock10";
